import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";
import {
  IDataPreference,
  IFilterIndicadores
} from "@/features/financas/views/Indicadores/@types/type";
import SaveVendasPanelToApi from "./services/SaveVendasPanelToApi";
import SavePagarEReceberToApi from "./services/SavePagarEReceberToApi";
import SaveNotasFiscaisToApi from "./services/SaveNotasFiscaisToApi";
import SaveReceitasVencidasToApi from "./services/SaveReceitasVencidasToApi";
import SaveFluxoDeCaixaToApi from "./services/SaveFluxoDeCaixaToApi";
import SaveConcialiacaoToApi from "./services/SaveConcialiacaoToApi";
import SaveDesempenhoVendasToApi from "./services/SaveDesempenhoVendasToApi";
import SaveDREToApi from "./services/SaveDREToApi";
import { injectable } from "inversify";
import "reflect-metadata";
import SaveFechamentoDeCaixaToApi from "./services/SaveFechamentoDeCaixaToApi";
import SaveVendasCanceladasToApi from "./services/SaveVendasCanceladasToApi";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// todo: refatorar esse mapper para não utilizar ANY (Vesentini)
const IWidgetsNamesMapper: Partial<Record<number, any>> = {
  [EWidgets.VendasPanel]: SaveVendasPanelToApi,
  [EWidgets.ExempleCard]: SavePagarEReceberToApi,
  [EWidgets.CardConciliacao]: SaveConcialiacaoToApi,
  [EWidgets.CardNotasFiscais]: SaveNotasFiscaisToApi,
  [EWidgets.CardReceitasVencidas]: SaveReceitasVencidasToApi,
  [EWidgets.FluxoCaixaPainel]: SaveFluxoDeCaixaToApi,
  [EWidgets.DREPanel]: SaveDREToApi,
  [EWidgets.DesempenhoVendas]: SaveDesempenhoVendasToApi,
  [EWidgets.CardFechamentoCaixa]: SaveFechamentoDeCaixaToApi,
  [EWidgets.CardVendasCanceladas]: SaveVendasCanceladasToApi
};

@injectable()
export default class CreatePreferencias {
  private preferencias: IDataPreference[] = [];

  buildPreferencias(filtros: IFilterIndicadores[]) {
    for (const filtro of filtros) {
      const classConstructor = IWidgetsNamesMapper[filtro.id];

      if (classConstructor) {
        const newInstance = new classConstructor();
        const newFilters = newInstance.buildPreference(filtro);

        if (Array.isArray(newFilters)) {
          this.preferencias.push(...(newFilters as IDataPreference[]));
        } else if (newFilters) {
          this.preferencias.push(newFilters);
        }
      }
    }

    return this.preferencias;
  }
}
